document.querySelectorAll('[data-omt-recommendations]').forEach((section) => {
  if (!section.dataset.url || section.children.length > 0) return;
  const observer = new IntersectionObserver((entries) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(section);
    fetch(section.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const fresh = html.querySelector('[data-omt-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) {
          section.innerHTML = fresh.innerHTML;
        }
      });
  }, { rootMargin: '0px 0px 200px 0px' });
  observer.observe(section);
});
